import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
    interface Window {
        dataLayer: any[];
    }
}

const RouteChangeTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Ensure dataLayer exists
        window.dataLayer = window.dataLayer || [];
        
        // Construct the page path including search parameters
        const pagePath = location.pathname + location.search;

        // Push the custom page view event to the dataLayer
        window.dataLayer.push({
            event: 'custom_page_view',
            page_path: pagePath,
        });
        
        // Log for debugging (optional, can be removed later)
        console.log(`GTM custom_page_view: ${pagePath}`); 

    }, [location.pathname, location.search]); // Rerun effect when path or search params change

    // This component does not render anything
    return null;
};

export default RouteChangeTracker; 